var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment_list empty"},[_vm._v(" 작성된 댓글이 없습니다."),_c('br'),_vm._v(" 작성한 댓글은 어린이들의 소중한 용기와 희망이 됩니다. ")])
}]

export { render, staticRenderFns }